export function matchesRegExp(expression: string, messageKey?: string) {
  const regExp = new RegExp(expression);
  return (value: string) => {
    return value && !regExp.test(value) && (messageKey || 'does not match expression');
  };
}
